import { render, staticRenderFns } from "./AddPlaceholder.vue?vue&type=template&id=43986f56&scoped=true&"
import script from "./AddPlaceholder.vue?vue&type=script&lang=js&"
export * from "./AddPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./AddPlaceholder.vue?vue&type=style&index=0&id=43986f56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43986f56",
  null
  
)

export default component.exports